// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AchTransaction } from './ach-transaction';
import { Dealer } from './dealer';
import { InvoiceLine } from './invoice-line';
import { InvoiceNote } from './invoice-note';
import { InvoiceStatus } from './invoice-status';
import { OrderLineDetail } from './order-line-detail';
import { PackingSlip } from './packing-slip';
import { PaymentLine } from './payment-line';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
import { Utility } from '../utility';
import { InvoicePaymentMethod, Payment } from './entity-model';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Invoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static SALES_TAX_RATE = 0.06;

    static getNextLineNumber(lines: any[]) {
        if (lines.length === 0) return 1;

        let lineNumber: any;
        lineNumber = _.maxBy(lines, 'lineNumber').lineNumber + 1;
        return lineNumber;
    }

    getNextLineNumber() {
        return Invoice.getNextLineNumber(this.invoiceLines);
    }

    get taxableTotal() {
        let subTotal = 0;
        if (!!this.invoiceLines) {
            this.invoiceLines
                .filter((x) => !x.deleted)
                .forEach((line) => {
                    if (!line.deleted && !line.orderLineDetail?.deleted && line.isTaxable) subTotal += line.quantity * line.price;
                });
        }
        return subTotal;
    }

    get invoiceSubTotal() {
        let subTotal = 0;
        if (!!this.invoiceLines) {
            this.invoiceLines.forEach((line) => {
                if (!line.deleted && !line.orderLineDetail?.deleted) subTotal += line.quantity * line.price;
            });
        }
        return subTotal;
    }

    get invoiceTaxTotal() {
        return Utility.round(this.taxableTotal * Invoice.SALES_TAX_RATE, 2);
    }

    get invoiceTotal() {
        return this.subTotal + this.invoiceTaxTotal;
    }

    get invoiceBalance() {
        return this.invoiceTotal - this.paymentsTotal;
    }

    get invoiceFees() {
        let feeTotal = 0;
        if (!!this.paymentLines) {
            this.paymentLines.forEach((line) => {
                if (!line.deleted && line.payment) feeTotal += line.payment.northpointFee;
            });
        }
        return feeTotal;
    }

    get paymentsTotal() {
        let paymentTotal = 0;
        if (!!this.paymentLines) {
            this.paymentLines.forEach((line) => {
                if (!line.deleted) paymentTotal += line.amount + line.creditAmount;
            });
        }
        return paymentTotal + this.invoiceFees;
    }

    get paymentMethods() {
        let methods = [];
        if (this.paymentLines && this.paymentLines.length > 0) {
            this.paymentLines.forEach((line) => {
                if (line.payment && line.payment.paymentMethod) {
                    const paymentMethod = line.payment.paymentMethod;
                    if (!_.includes(methods, paymentMethod)) methods.push(paymentMethod);
                }
            });
        }
        return methods;
    }

    get paidByNorthpoint() {
        return this.paymentMethods.some((method) => method.isFloorplanMethod);
    }

    get northPointPaymentAmount() {
        let amount = 0;
        if (!!this.paymentLines) {
            this.paymentLines.forEach((line) => {
                if (!line.deleted && line.payment && line.payment.paymentMethod.isFloorplanMethod) amount += line.payment.northpointFee;
            });
        }
        return amount;
    }

    get packingSlipList() {
        const list = [];
        if (!!this.invoiceLines) {
            this.invoiceLines.forEach((line) => {
                if (!!line.orderLineDetail && line.orderLineDetail.packingSlip) {
                    if (!_.includes(list, line.orderLineDetail.packingSlip.packingSlipNumber)) list.push(line.orderLineDetail.packingSlip.packingSlipNumber);
                }
            });
            if (!!this.packingSlipFreights && this.packingSlipFreights.length > 0) {
                this.packingSlipFreights.forEach((freight) => {
                    if (!_.includes(list, freight.packingSlipNumber)) list.push(freight.packingSlipNumber);
                });
            }
        }
        return list;
    }

    get packingSlipListString() {
        return this.packingSlipList.join('; ');
    }

    get ordersList() {
        const orderList = [];
        if (!!this.invoiceLines) {
            this.invoiceLines.forEach((line) => {
                if (line.orderLineDetail) {
                    if (!_.includes(orderList, line.orderLineDetail.orderLine?.order?.invoiceNumber)) orderList.push(line.orderLineDetail.orderLine.order.invoiceNumber);
                }
            });
        }
        return orderList;
    }

    get ordersListString() {
        let orderList = this.ordersList;
        return orderList.join('; ');
    }

    get orderPaymentMethodsList() {
        const paymentMethodList = [];
        if (!!this.invoiceLines) {
            this.invoiceLines.forEach((line) => {
                const paymentMethod = line.orderLineDetail?.orderLine?.order?.paymentMethod;
                if (paymentMethod && !_.includes(paymentMethodList, paymentMethod)) paymentMethodList.push(paymentMethod);
            });
        }
        return paymentMethodList;
    }

    get orderPaymentMethodsListString() {
        return this.orderPaymentMethodsList.join(', ');
    }

    get invoiceShipInfo() {
        let shipInfo = {};
        return shipInfo;
        // if (!this.invoiceLines || this.invoiceLines.length === 0) return shipInfo;
        // const order = this.invoiceLines[0].orderLineDetail?.orderLine.order;
        // return (shipInfo = {
        //     shipAddressId: order.shipAddressId,
        //     shipToContactName: order.shipToContactName,
        //     shipToLocation: order.shipToLocation,
        //     shipToAddress1: order.shipToAddress1,
        //     shipToAddress2: order.shipToAddress2,
        //     shipToCity: order.shipToCity,
        //     shipToState: order.shipToState,
        //     shipToZip: order.shipToZip,
        //     shipToCountry: order.shipToCountry,
        //     shipToPhone: order.shipToPhone,
        //     shipToEmail: order.shipToEmail,
        //     shippingNote: order.shippingNote,
        // });
    }

    get canExport() {
        let allComplete = true;
        if (!this.orderLineDetails || this.orderLineDetails.length === 0) return false;
        this.orderLineDetails.forEach((detail) => {
            if (detail.statusId !== OrderLineDetail.Statuses.Complete) allComplete = false;
        });
        return allComplete;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  balance!: number;
  created!: Date;
  createdBy?: string;
  dealerId!: number;
  deleted?: Date;
  deletedBy?: string;
  deliveryMethod?: string;
  dueDate?: Date;
  emailed?: Date;
  freight!: number;
  invoiceDate?: Date;
  invoiceNumber?: number;
  notes?: string;
  paid?: Date;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  readyToExport?: Date;
  readyToExportBy?: string;
  reportGuid?: string;
  statusId?: number;
  subTotal!: number;
  tax!: number;
  total!: number;
  achTransactions!: AchTransaction[];
  dealer!: Dealer;
  invoiceLines!: InvoiceLine[];
  invoiceNotes!: InvoiceNote[];
  orderLineDetails!: OrderLineDetail[];
  packingSlipFreights!: PackingSlip[];
  paymentLines!: PaymentLine[];
  status!: InvoiceStatus;
}

